import _this from "../../main";
import router from '../../router'
import moment from 'moment'

export default {
  install(Vue) {

    //================ 用户校验相关

    //根据sessionKey获取用户信息 全局函数
    Vue.prototype.getUserInfo = function (userinfosessionKey, redirect, callback) {

      // console.log(redirect)
      // console.log(callback)
      // console.log(userinfosessionKey)
      // return false;
      redirect = redirect ? decodeURIComponent(redirect) : undefined;

      _this.axios.get(_this.$store.state.api.gra_api + 'login/ssoLogin/' + userinfosessionKey, _this.qs.stringify({})).then(function (res) {

        // console.log(res);

        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              // console.error(res.data.msg ? res.data.msg : '自动登录失败——0');
              _this.$router.replace({ path: '/login', query: { redirect: redirect } });
              console.error(error);
              return false;
            }
          }

          if (res.data.status) {
            const fetch_data = res.data.data;

            // console.log(fetch_data);

            if (fetch_data.status == 0) {
              _this.$dialog.confirm({
                closeOnPopstate: true,//页面回退时自动关闭
                title: '账户失效',
                message: '当前账户已冻结，请选择正确的账号登录',
                showCancelButton: false,
                confirmButtonText: '返回登录',
              }).then(() => {
                if (_this.$store.state.browser.giantopoapp) {
                  if (_this.$store.state.browser.ios) {
                    window.webkit.messageHandlers.back.postMessage('');
                  } else {
                    android.back();
                  }
                } else {
                  _this.$router.replace({ path: '/login', query: { redirect: redirect } })
                }
              }).catch(() => {
              });
              return false;
            }

            let user_data = {
              sessionkey: fetch_data.token,
              usercode: fetch_data.code,
              id: fetch_data.user_id,
              username: fetch_data.username,
              nickname: fetch_data.name ? fetch_data.name : '无昵称',
              code_name: fetch_data.code_name,
              phone: fetch_data.phone,
              avatar: fetch_data.avatar,
              sex: fetch_data.sex,

              sbucode: fetch_data.sbu,
              sbu_name: fetch_data.sbu_name,
              dealercode: fetch_data.dealercode,
              dealer_name: fetch_data.dealer_name,
              shopno: fetch_data.shopno,

              parentInfo: fetch_data.parentInfo,

              is_teacher: fetch_data.is_teacher,
              all_jobs: fetch_data.all_jobs,
              all_orgs: fetch_data.all_orgs,
              is_only_store: fetch_data.is_only_store,

            }



            // "parentInfo": {
            //   "m_type": "store",
            //   "code": "8165", //组织code
            //   "org_id": 40,
            //   "m_code": "8165"
            // } //主节点信息 （数据统计需要使用）

            if (fetch_data.is_teacher) {
              user_data.teacher_id = fetch_data.teacher_id;
            }
            // alert(_this.$store.state.api.gra_api + 'login/ssoLogin/'+userinfosessionKey);
            // alert(fetch_data);
            // alert(fetch_data.is_can_login);
            //本地存储
            localStorage.setItem('giant_userselect', fetch_data.is_can_login == 1 ? '1' : '0');

            localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session
            //sessionStorage.setItem('user_','#/IndexA');

            //读取
            //console.log( localStorage.getItem('user_data') );
            //console.log( JSON.parse(localStorage.getItem('user_data')) );

            callback && callback();

            if (redirect) {
              // console.log(redirect);
              // return false;
              location.replace(redirect);
              return false;

            } else {
              _this.$router.replace({ path: '/' });
            }




          } else {
            console.error(res.data.msg ? res.data.msg : '自动登录失败——1');


            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '提示',
              message: res.data.msg ? res.data.msg : '登录失效',
              showCancelButton: false,
              confirmButtonText: '重新登录',
            }).then(() => {
              if (_this.$store.state.browser.giantopoapp) {
                if (_this.$store.state.browser.ios) {
                  window.webkit.messageHandlers.back.postMessage('');
                } else {
                  android.back();
                }
              } else {
                _this.$router.replace({ path: '/login', query: { redirect: redirect } })
              }
            }).catch(() => {
            });
          }

        } else {
          console.error(res.data.msg ? res.data.msg : '自动登录失败——2');

          _this.$dialog.confirm({
            closeOnPopstate: true,//页面回退时自动关闭
            title: '提示',
            message: res.data.msg ? res.data.msg : '登录失效',
            showCancelButton: false,
            confirmButtonText: '重新登录',
          }).then(() => {
            if (_this.$store.state.browser.giantopoapp) {
              if (_this.$store.state.browser.ios) {
                window.webkit.messageHandlers.back.postMessage('');
              } else {
                android.back();
              }
            } else {
              _this.$router.replace({ path: '/login', query: { redirect: redirect } })
            }
          }).catch(() => {
          });
          // _this.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '请求用户失败',
          //   message: '出现了一些问题',
          //   showCancelButton: false,
          //   confirmButtonText: '前往opo登录',
          // }).then(() => {
          //   location.replace(_this.$store.state.externalurl.opo);
          // }).catch(() => {
          // });
        }

      }).catch(function (error) {
        console.log('自动登录失败——3')

        _this.$dialog.confirm({
          closeOnPopstate: true,//页面回退时自动关闭
          title: '提示',
          message: '当前账号已在其他设备登录',
          showCancelButton: false,
          confirmButtonText: '重新登录',
        }).then(() => {
          if (_this.$store.state.browser.giantopoapp) {
            if (_this.$store.state.browser.ios) {
              window.webkit.messageHandlers.back.postMessage('');
            } else {
              android.back();
            }
          } else {
            _this.$router.replace({ path: '/login', query: { redirect: redirect } })
          }
        }).catch(() => {
        });
        // _this.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '获取用户信息出错',
        //   message: '出现了一些问题',
        //   showCancelButton: false,
        //   confirmButtonText: '前往opo登录',
        // }).then(() => {
        //   location.replace(_this.$store.state.externalurl.opo);
        // }).catch(() => {
        // });
        console.error(error);
      });
    }

    //刷新sessionKey（token） 全局函数
    window.refreshToken = (res) => {
      _this.refreshTokens(res);
    };

    Vue.prototype.refreshTokens = function (token) {
      let user_data = JSON.parse(localStorage.getItem('giant_userdata'));

      user_data.sessionkey = token;

      //本地存储
      localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session

      _this.$store.commit('updateLoginUser', user_data);
    }

    //callback 成功，sorryFn 失败
    Vue.prototype.refreshToken = function (callback, sorryFn) {


      //如果在App环境中，调用App的刷新Token方法
      if (_this.$store.state.browser.giantopoapp) {

        let _token = '';

        if (_this.$store.state.browser.ios) {
          // _token = window.webkit.messageHandlers.opoOC.getToken();
          window.webkit.messageHandlers.getToken.postMessage('');
        } else {
          _token = android.getToken();

          let user_data = JSON.parse(localStorage.getItem('giant_userdata'));

          user_data.sessionkey = _token;

          //本地存储
          localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session

          _this.$store.commit('updateLoginUser', user_data);
        }
        return false;
      }

      // console.log(_this.GLOBAL.pageApiUrl + '/user/checkUserInfo')
      // console.log(userinfosessionKey)

      _this.axios.post(_this.$store.state.api.login_api + '/refreshLogin?sessionKey=' + _this.$store.state.loginUser.sessionkey, _this.qs.stringify({
        token: _this.$store.state.loginUser.sessionkey
      })).then(function (res) {

        // console.log(res);

        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              console.error(error);
              if (sorryFn) {
                if (typeof sorryFn == "function") {
                  sorryFn();
                } else {
                  _this.$dialog.confirm({
                    closeOnPopstate: true,//页面回退时自动关闭
                    title: res.data.msg,
                    message: '您可以尝试：',
                    confirmButtonText: '重新登录',
                    cancelButtonText: '刷新重试'
                  }).then(() => {
                    //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath }});

                    if (_this.$store.state.browser.giantopoapp) {
                      if (_this.$store.state.browser.ios) {
                        window.webkit.messageHandlers.back.postMessage('');
                      } else {
                        android.back();
                      }
                    } else {
                      _this.$router.replace({ path: '/login', query: { redirect: location.href } });
                    }
                  }).catch(() => {
                    location.reload(true);
                  });
                }
              }
              return false;
            }
          }
          if (res.data._status) {

            let user_data = JSON.parse(localStorage.getItem('giant_userdata'));
            if (res.data._status) {
              user_data.sessionkey = res.data.sessionKey;
            } else {
              if (_this.$store.state.browser.giantopoapp) {
                if (_this.$store.state.browser.ios) {
                  window.webkit.messageHandlers.back.postMessage('');
                } else {
                  android.back();
                }
              } else {
                _this.$router.replace({ path: '/login', query: { redirect: location.href } });
              }
              return false;
            }

            //本地存储
            localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session

            _this.$store.commit('updateLoginUser', user_data);

            //const fetch_data = res.data.data;
            //console.log(fetch_data);
            if (typeof callback == "function") {
              setTimeout(function () {
                callback();
              }, Math.ceil(Math.random() * 500));//增加<500毫秒的延时
            }

          } else {
            //_this.$toast('更新令牌出现了一些问题');
            if (sorryFn) {
              if (typeof sorryFn == "function") {
                sorryFn();
              } else {
                _this.$dialog.confirm({
                  closeOnPopstate: true,//页面回退时自动关闭
                  title: res.data.msg ? res.data.msg : '更新令牌出现了一些问题',
                  message: '您可以尝试：',
                  confirmButtonText: '重新登录',
                  cancelButtonText: '返回上一页'
                }).then(() => {
                  //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath }});
                  _this.$router.replace({ path: '/login', query: { redirect: location.href } });
                }).catch(() => {
                  history.back();
                });
              }
            }
          }

        } else {
          //_this.$toast('请求更新令牌失败');
          if (sorryFn) {
            if (typeof sorryFn == "function") {
              sorryFn();
            } else {
              _this.$dialog.confirm({
                closeOnPopstate: true,//页面回退时自动关闭
                title: '请求更新令牌失败',
                message: '您可以尝试：',
                confirmButtonText: '重新登录',
                cancelButtonText: '返回上一页'
              }).then(() => {
                //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath }});
                _this.$router.replace({ path: '/login', query: { redirect: location.href } });
              }).catch(() => {
                history.back();
              });
            }
          }
        }

      }).catch(function (error) {
        console.error(error);
        if (sorryFn) {
          if (typeof sorryFn == "function") {
            sorryFn();
          } else {
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '更新令牌出现异常',
              message: '您可以尝试：',
              confirmButtonText: '重新登录',
              cancelButtonText: '返回上一页'
            }).then(() => {
              //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath }});
              _this.$router.replace({ path: '/login', query: { redirect: location.href } });
            }).catch(() => {
              history.back();
            });
          }
        }
      });
    };

    //判断骑行App版本 atleast 至少
    Vue.prototype.checkGiantAppVersion = function (limit_giantappversion, atleast) {

      let matches = window.navigator.userAgent.toLowerCase().match(/_giantapp\/([\d]+)\.([\d]+)\.([\d]+)/);
      if (matches) {
        let limit_var = limit_giantappversion.split('.');
        if (atleast) {
          if (Number(matches[1]) > Number(limit_var[0])) {
            return true;
          } else if (Number(matches[1]) == Number(limit_var[0])) {
            if (Number(matches[2]) > Number(limit_var[1])) {
              return true;
            } else if (Number(matches[2]) == Number(limit_var[1])) {
              return Number(matches[3]) >= Number(limit_var[2]);
            }
          } else {
            return false;
          }
        } else {
          if (Number(limit_var[0]) > Number(matches[1])) {
            return true;
          } else if (Number(limit_var[0]) == Number(matches[1])) {
            if (Number(limit_var[1]) > Number(matches[2])) {
              return true;
            } else if (Number(limit_var[1]) == Number(matches[2])) {
              return Number(limit_var[2]) > Number(matches[3]);
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }

    };
    // 判断捷安特经营助手app的版本
    Vue.prototype.checkGiantJYVersion = function (limit_giantappversion, atleast) {

      let matches = window.navigator.userAgent.toLowerCase().match(/_giantopoapp\/([\d]+)\.([\d]+)\.([\d]+)/);
      if (matches) {
        let limit_var = limit_giantappversion.split('.');
        if (atleast) {
          if (Number(matches[1]) > Number(limit_var[0])) {
            return true;
          } else if (Number(matches[1]) == Number(limit_var[0])) {
            if (Number(matches[2]) > Number(limit_var[1])) {
              return true;
            } else if (Number(matches[2]) == Number(limit_var[1])) {
              return Number(matches[3]) >= Number(limit_var[2]);
            }
          } else {
            return false;
          }
        } else {
          if (Number(limit_var[0]) > Number(matches[1])) {
            return true;
          } else if (Number(limit_var[0]) == Number(matches[1])) {
            if (Number(limit_var[1]) > Number(matches[2])) {
              return true;
            } else if (Number(limit_var[1]) == Number(matches[2])) {
              return Number(limit_var[2]) > Number(matches[3]);
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }

    };

    //================ 工具相关

    //返回上一页
    Vue.prototype.backToPrevpage = function () {
      if (history.length > 1) {
        router.go(-1);
      } else {
        if (_this.$store.state.browser.giantopoapp) {
          if (_this.$store.state.browser.ios) {
            window.webkit.messageHandlers.back.postMessage('');
          } else {
            android.back();
          }
        } else {
          router.push({ path: '/' });
        }
      }
    };

    //返回首页
    Vue.prototype.goToHome = function () {
      router.replace({ path: '/' });
    };

    //返回页面顶部
    Vue.prototype.gotoPageTop = function () {
      // document.scrollingElement.scrollTop = 0;
      let currentPosition, timer
      timer = setInterval(function () {
        currentPosition = document.documentElement.scrollTop || document.body.scrollTop
        currentPosition -= 10
        if (currentPosition > 0) {
          window.scrollTo(0, currentPosition)
        } else {
          window.scrollTo(0, 0)
          clearInterval(timer)
        }
      }, 1)
    };

    //关闭qrcode系统
    Vue.prototype.closePrevpage = function () {
      if (_this.$store.state.browser.ios) {
        window.webkit.messageHandlers.closeWebView.postMessage('');
      } else {
        android.closeWebView();
      }
    };

    //复制到剪贴板
    Vue.prototype.copyToClipboard = function (content) {
      console.log(content)
      const textString = content.toString();//数字没有 .length 不能执行selectText 需要转化成字符串
      let input = document.querySelector('#copy-input');
      if (!input) {
        input = document.createElement('input');
        input.id = "copy-input";
        input.readOnly = "readOnly";        // 防止ios聚焦触发键盘事件
        input.style.position = "absolute";
        input.style.left = "-1000px";
        input.style.zIndex = "-1000";
        document.body.appendChild(input)
      }

      input.value = textString;
      // ios必须先选中文字且不支持 input.select();
      selectText(input, 0, textString.length);
      //console.log(document.execCommand('copy'), 'execCommand');
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        //alert('已复制到粘贴板');
      }
      input.blur();

      // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
      // 选择文本。createTextRange(setSelectionRange)是input方法
      function selectText(textbox, startIndex, stopIndex) {
        if (textbox.createTextRange) {//ie
          const range = textbox.createTextRange();
          range.collapse(true);
          range.moveStart('character', startIndex);//起始光标
          range.moveEnd('character', stopIndex - startIndex);//结束光标
          range.select();//不兼容苹果
        } else {//firefox/chrome
          textbox.setSelectionRange(startIndex, stopIndex);
          textbox.focus();
        }
      }

      /*
      if (window.clipboardData) {
        window.clipboardData.setData('text', content);
      } else {
        (function (content) {
          document.oncopy = function (e) {
            e.clipboardData.setData('text', content);
            e.preventDefault();
            document.oncopy = null;
          }
        })(content);
        document.execCommand('Copy');
      }
      */
    };

    //页面滚动到，全局函数
    //https://stackoverflow.com/questions/21474678/scrolltop-animation-without-jquery
    Vue.prototype.scrollToTop = function (duration = 500, targettop = 100, linear = false) {
      // cancel if already on top
      if (document.scrollingElement.scrollTop === targettop) return;
      if (linear) {
        const cosParameter = document.scrollingElement.scrollTop - targettop;
        let scrollY = cosParameter, oldTimestamp = null;
        let firstTimestamp = null;//通过时间戳判断何时终止
        function step(newTimestamp) {
          if (firstTimestamp === null) {
            firstTimestamp = newTimestamp;
          }
          if (oldTimestamp !== null) {
            scrollY -= cosParameter * (newTimestamp - oldTimestamp) / duration;
            //if (scrollY > -10 && scrollY < 10) return document.scrollingElement.scrollTop = targettop;
            if (oldTimestamp - firstTimestamp >= duration) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop + scrollY;
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      } else {
        const cosParameter = (targettop - document.scrollingElement.scrollTop) / 2;
        let scrollCount = 0, oldTimestamp = null;
        function step(newTimestamp) {
          if (oldTimestamp !== null) {
            // if duration is 0 scrollCount will be Infinity
            scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration;
            if (scrollCount >= Math.PI) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop - (cosParameter + cosParameter * Math.cos(scrollCount));
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      }
    };

    //通过经纬度计算距离，返回公里数
    Vue.prototype.calcDistance = function (lat1, lng1, lat2, lng2) {
      function Rad(d) {
        return d * Math.PI / 180.0;//经纬度转换成三角函数中度分表形式。
      }
      var radLat1 = Rad(lat1);
      var radLat2 = Rad(lat2);
      var a = radLat1 - radLat2;
      var b = Rad(lng1) - Rad(lng2);
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
        Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
      s = s * 6378.137;// EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000; //输出为公里
      //s=s.toFixed(4);
      return s;
    };

    //获取用户当前位置（定位）
    Vue.prototype.getUserPostion = function (mustReFresh = false, fnCallback, fnError) {


      if (!mustReFresh) {//非强制刷新
        let tmpUserpostion = JSON.parse(localStorage.getItem('giant_userpostion'));
        if (tmpUserpostion && tmpUserpostion.lat) {
          fnCallback && fnCallback(tmpUserpostion);
        } else {
          _this.getUserPostion(true, fnCallback, fnError);
        }
        return false;
      }

      window.onGaodeLoad = function () {
        _this.getUserPostion(mustReFresh, fnCallback, fnError);
      }
      if (typeof (AMap) == "undefined") {
        var url = 'https://webapi.amap.com/maps?v=2.0&key=d94102a2b4b53d8d81de63aec201ae4a&callback=onGaodeLoad';
        var jsapi = document.createElement('script');
        jsapi.charset = 'utf-8';
        jsapi.src = url;
        document.head.appendChild(jsapi);
      } else {
        let map, geolocation;
        map = new AMap.Map(document.createElement('div'), {
          //resizeEnable: true
        });
        map.plugin('AMap.Geolocation', function () {
          geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 10000, //超过10秒后停止定位，默认：无穷大
          });
          geolocation.getCurrentPosition(function (status, result) {
            if (status == 'complete') {
              //console.log(result.position);

              let userpostion_data = {
                lat: result.position.getLat(),//高精 //result.position.lat
                lng: result.position.getLng(),//高精 //result.position.lng
              }
              //console.log(userpostion_data);

              //本地存储
              localStorage.setItem('giant_userpostion', JSON.stringify(userpostion_data));//session

              fnCallback && fnCallback(userpostion_data);

            } else {
              //onError(result)
              //alert(2);
              fnError && fnError(result);
            }
          });
        });

      }


    };

    //美化价格的显示 num 待美化的价格 fixed 几位小数 round 四舍五入 thousand 千位符
    Vue.prototype.priceSexy = function (num, fixed = 2, round = true, thousand = false) {
      if (isNaN(num)) {
        return num;
      }
      if (fixed >= 0) {
        if (round) {
          num = (Number(num)).toFixed(fixed);
        } else {
          num = (Math.floor(num * 100) / 100).toFixed(fixed);
        }
      }
      if (thousand) {
        var numarr = num.split(".");
        if (numarr.length) {
          num = (numarr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        }
        if (numarr.length > 1 && numarr[1] != "") {
          num = "" + num + "." + numarr[1];
        }
      }
      return num;
    };

    //计算 解决js运算bug
    Vue.prototype.mathcalc = function (a, b, mode = '+') {

      if (mode == '-') {//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_this.mathcalc(a, e, '*') - _this.mathcalc(b, e, '*')) / e;
      } else if (mode == '*') {//=========================
        let c = 0,
          d = a.toString(),
          e = b.toString();
        try {
          c += d.split('.')[1].length;
        } catch (f) { }
        try {
          c += e.split('.')[1].length;
        } catch (f) { }
        return Number(d.replace('.', '')) * Number(e.replace('.', '')) / Math.pow(10, c);
      } else if (mode == '/') {//=========================
        let c, d, e = 0, f = 0;
        try {
          e = a.toString().split('.')[1].length;
        } catch (g) { }
        try {
          f = b.toString().split('.')[1].length;
        } catch (g) { }
        return c = Number(a.toString().replace('.', '')), d = Number(b.toString().replace('.', '')), _this.mathcalc(c / d, Math.pow(10, f - e), '*');
      } else {//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_this.mathcalc(a, e, '*') + _this.mathcalc(b, e, '*')) / e;
      }
    };

    //格式化时间戳
    Vue.prototype.dateformat = function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
      if (dataStr.toString().length < 13) {
        dataStr *= 1000;
      }
      return moment(dataStr).format(pattern);
    };

    // 获取当前一周内的所有时间
    Vue.prototype.getWeekDataList = function (data) {
          //根据日期获取本周周一~周日的年-月-日
      var weekList = [];
      var date = new Date(data);
      //判断本日期是否为周日，获取本周一日期
      if(date.getDay()=="0"){
        date.setDate(date.getDate() -6);
      }else {
        date.setDate(date.getDate() - date.getDay() + 1);
      }
      var myDate=date.getDate();
      var myMonth=date.getMonth() + 1;
      if(date.getDate()<10){
        myDate= '0'+ myDate;
      }
      if(date.getMonth() + 1<10){
        myMonth='0'+myMonth;
      }
      weekList.push(date.getFullYear() + "-" + myMonth+ "-" + myDate);
      // 获取周二以后日期
      for(var i=0;i<6;i++) {
        date.setDate(date.getDate() + 1);
        myDate=date.getDate();
        myMonth=date.getMonth() + 1;
        if(date.getDate()<10){
          myDate= '0'+ myDate;
        }
        if(date.getMonth() + 1<10){
          myMonth='0'+myMonth;
        }
        weekList.push(date.getFullYear() + "-" + myMonth+ "-" +myDate);
      }
      return weekList
    };


    //秒转时分秒
    Vue.prototype.formateTime = function (time) {
      const h = parseInt(time / 3600)
      const minute = parseInt(time / 60 % 60)
      const second = Math.ceil(time % 60)

      const hours = h < 10 ? '0' + h : h
      const formatSecond = second > 59 ? 59 : second;

      return `${hours > 0 ? `${hours + '时'}` : ''}${minute < 10 ? '0' + minute + '分' : minute + '分'}${formatSecond < 10 ? '0' + formatSecond + '秒' : formatSecond + '秒'}`
    };
    Vue.prototype.formateEmoji = function (value) {

      value = value.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, "")
      // return value.replace(/(^\s*)|(\s*$)/g, "").trim();
      return value;
    }
    //base64转Blob
    Vue.prototype.dataURItoBlob = function (dataURI) {
      var byteString = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    };

    //压缩图片
    //width 宽、height 高、quality 质量、longside 长边（优先级高过宽高）、shortside 短边（优先级最高）
    Vue.prototype.compressImage = function (file, callback, config) {

      if (file.type == 'image/gif' || file.type == 'image/jpeg' || file.type == 'image/pjpeg' || file.type == 'image/png' || file.type == 'image/x-png') {

        let tmpParams = {
          width: 1000,
          quality: 0.8
        };

        tmpParams = Object.assign(tmpParams, config);

        //通过canvas压缩图片
        var reader = new FileReader();
        reader.readAsDataURL(file.file);
        var img = new Image;
        reader.onload = function (e) {
          //var width = 1080; //图像大小
          //var quality = 0.8; //图像质量
          var canvas = document.createElement("canvas");
          var drawer = canvas.getContext("2d");
          img.src = this.result;
          img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;

            if (tmpParams.shortside) {
              if (img.width > img.height) {
                tmpParams.height = tmpParams.shortside;
                tmpParams.width = tmpParams.height * (img.width / img.height);
              } else if (img.height > img.width) {
                tmpParams.width = tmpParams.shortside;
                tmpParams.height = tmpParams.width * (img.height / img.width);
              }
            } else if (tmpParams.longside) {
              tmpParams.width = tmpParams.height = tmpParams.longside;
            }
            if (tmpParams.width && tmpParams.width < img.width) {
              canvas.width = tmpParams.width;
              canvas.height = tmpParams.width * (img.height / img.width);
            }
            if (tmpParams.height && tmpParams.height < canvas.height) {
              canvas.height = tmpParams.height;
              canvas.width = tmpParams.height * (img.width / img.height);
            }
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
            let tmpType = 'image/jpeg';
            if (file.file.type == 'image/png' || file.file.type == 'image/x-png') {
              tmpType = 'image/png';
            }
            file.file = new window.File([_this.dataURItoBlob(canvas.toDataURL(tmpType, tmpParams.quality))], file.file.name, { type: file.file.type });
            callback && callback(file);
          }
        }
      } else {
        callback && callback(file);
      }
    };
    Vue.prototype.compressImgNew = function(fileObj) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(fileObj);
        reader.onload = function (e) {
          let image = new Image(); //新建一个img标签（不嵌入DOM节点，仅做canvas操作)
          image.src = e.target.result; //让该标签加载base64格式的原图
          image.onload = function () {
            //图片加载完毕后再通过canvas压缩图片，否则图片还没加载完就压缩，结果图片是全黑的
            let canvas = document.createElement("canvas"), //创建一个canvas元素
              context = canvas.getContext("2d"), //context相当于画笔，里面有各种可以进行绘图的API
              imageWidth = image.width / 2, //压缩后图片的宽度，这里设置为缩小一半
              imageHeight = image.height / 2, //压缩后图片的高度，这里设置为缩小一半
              data = ""; //存储压缩后的图片
            canvas.width = imageWidth; //设置绘图的宽度
            canvas.height = imageHeight; //设置绘图的高度

            //使用drawImage重新设置img标签中的图片大小，实现压缩。drawImage方法的参数可以自行查阅W3C
            context.drawImage(image, 0, 0, imageWidth, imageHeight);
            //使用toDataURL将canvas上的图片转换为base64格式
            data = canvas.toDataURL("image/jpeg");
            canvas.toBlob(function (blob) {
              const f = new File([blob], fileObj.name, { type: "image/jpeg" });
              resolve(f);
            }, "image/jpeg");
          };
        };
      });
    },
    //手机号校验
    Vue.prototype.checkPhone = function (phone) {
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        return false;
      } else {
        return true;
      }
    }

    //邮箱校验
    Vue.prototype.checkEmail = function (email) {
      let regEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (regEmail.test(email)) {
        return true;
      } else {
        return false;
      }
    }
    // 手机号或者固定电话
    Vue.prototype.checkFixPhone = function (phone) {
      if (!/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(phone)) {
        return false;
      } else {
        return true;
      }
    }
    // 港澳台居民来往内地通行证
    Vue.prototype.isHKCard = function (card) {
      // 规则： H/M + 10位或6位数字
      // 样本： H1234567890
      // var reg = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/;
      var reg = /^[0-9a-zA-Z]{1,18}$/;
      if (reg.test(card) === false) {
        return false;
      } else {
        return true;
      }
    }
    // 身份证校验
    Vue.prototype.checkIDCard = function (idcode) {
      // 加权因子
      var weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      // 校验码
      var check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];

      var code = idcode + "";
      var last = idcode[17]; //最后一位

      var seventeen = code.substring(0, 17);

      // ISO 7064:1983.MOD 11-2
      // 判断最后一位校验码是否正确
      var arr = seventeen.split("");
      var len = arr.length;
      var num = 0;
      for (var i = 0; i < len; i++) {
        num = num + arr[i] * weight_factor[i];
      }

      // 获取余数
      var resisue = num % 11;
      var last_no = check_code[resisue];

      // 格式的正则
      // 正则思路
      /*
    第一位不可能是0
    第二位到第六位可以是0-9
    第七位到第十位是年份，所以七八位为19或者20
    十一位和十二位是月份，这两位是01-12之间的数值
    十三位和十四位是日期，是从01-31之间的数值
    十五，十六，十七都是数字0-9
    十八位可能是数字0-9，也可能是X
    */
      var idcard_patter =
        /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2]\d|3[0-1])\d{3}[\dX]$/;

      // 判断格式是否正确
      var format = idcard_patter.test(idcode);

      // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
      let jieguo = last === last_no && format ? true : false;
      console.log("身份证是否有效：", jieguo);

      return jieguo;
    }
    // 校验护照
    Vue.prototype.checkPassPortCard = function (card) {
      // 护照
      // 规则： 14/15开头 + 7位数字, G + 8位数字, P + 7位数字, S/D + 7或8位数字,等
      // 样本： 141234567, G12345678, P1234567
      var reg = /^([a-zA-z]|[0-9]){5,17}$/;
      if (reg.test(card) === false) {
        return false;
      } else {
        return true;
      }
    }

    //初始化微信分享
    Vue.prototype.funWxShare = function (shareConfig = {}) {


      if (_this.$store.state.browser.wx) {

        let tmpParams = {
          re_url: location.href,//_this.$store.state.siteUrl,//分享链接URL
        }

        //对 iOS 特殊处理
        if (_this.$store.state.browser.ios) {
          if (!sessionStorage.getItem('firsttouch4ios')) {//将入口地址保存下来，iOS 分享会使用
            sessionStorage.setItem('firsttouch4ios', window.location.href);
          }
          tmpParams.re_url = sessionStorage.getItem('firsttouch4ios');
        }

        _this.axios.post('https://wechat.giant.com.cn/third/wechat.ashx?action=jspack2', _this.qs.stringify({
          apiname: 'Giant',
          apipwd: 'Dline!@1587',
          wxname: 'giantfwh',
          url: location.href.split('#')[0]
        })).then(function (res) {

          const fetch_data = res.data.jspack;

          let json_config = {
            debug: false,
            appId: fetch_data.appId,//_this.$store.state.wxAppId
            timestamp: fetch_data.timeStamp ? fetch_data.timeStamp : 1,
            nonceStr: fetch_data.nonceStr ? fetch_data.nonceStr : '',
            signature: fetch_data.signatureStr ? fetch_data.signatureStr : '',
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'updateAppMessageShareData', 'updateTimelineShareData']
          }

          wx.config(json_config);

          //console.log(json_config);

          wx.error(function (res) {
          });
          wx.ready(function () {
            var shareData = {
              title: '捷安特GRA微学平台',
              desc: 'GRA微学平台是专为全国通路量身定制、专业且全方位人才训练的线上学习平台',
              link: location.href,
              imgUrl: 'http://giant-images.oss-cn-shanghai.aliyuncs.com/gra/images/gra_share.png',
              success: function (res) {
              },
              cancel: function (res) {
              }
            };

            shareData = Object.assign(shareData, shareConfig);

            wx.onMenuShareTimeline(shareData);
            wx.onMenuShareAppMessage(shareData);
            wx.updateAppMessageShareData(shareData);
            wx.updateTimelineShareData(shareData);
          });

          /* 处理失败验证 */
          wx.error(function (res) {
            // config 信息验证失败会执行error函数,如签名过期导致验证失败,具体错误信息可以打开config的debug模式查看,也可以在返回的res参数中查看,对于SPA可以在这里更新签名
            alert('配置验证失败: ' + res.errMsg)
          })

        }).catch(function (error) {
          _this.$toast('出现了一些问题');
        });

      }

    };


    //判断字符串中是否有超过2字节的字符（是否有emoji表情）
    Vue.prototype.is32Bit = function (substring) {
      for (var i = 0; i < substring.length; i++) {
        if (substring.codePointAt(i) > 0xFFFF) {
          return true;
        }
      }
      return false;
    };

    //判断字符串中多少个字节
    Vue.prototype.stringByteCount = function (substring) {
      if (!arguments.length || !substring) return null;
      if ('' == substring) return 0;
      var l = 0;
      for (var i = 0; i < substring.length; i++) {
        if (substring.charCodeAt(i) > 255) l += 2;
        else l++;
      }
      return l;
    };

    //================ 业务相关

    //行为埋点
    Vue.prototype.setBehaviorPoint = function (json) {


      //return false;//埋点先关掉

      let tmpParams = {
        SYS: 'SHOP',//平台code
        PAGE: '',//PAGE 来源对照表https://docs.qq.com/sheet/DSUZHWEJBWFhqSHN1?tab=BB08J2
        PID: '',//如果是商品传商品id
        title: document.title,
        action: '',//A1 页访
        VAL: 1,
        info: document.title ? document.title : '捷安特GRA学习系统',
        UserID: '',
        shopno: '',
        deviceId: '',//设备ID，目前没有用到可以传空
        objCode: 0,//0 无  1商品  2活动 3新闻
      }

      tmpParams = Object.assign(tmpParams, json);

      _this.axios.post(_this.$store.state.api.common + 'behavior/send_behavior_json', _this.qs.stringify(
        tmpParams
      )).then(function (res) {
      }).catch(function (error) {
      });
    };

    //GRA页面数据埋点
    Vue.prototype.GraburyingPoint = function (id, type, title) {
      let tmpParams = {
        user_id: _this.$store.state.loginUser.sessionkey,
        id: id ? id : '', //非必填 
        title: title ? title : '',
        type: type //1首页2课程详情页3培训详情页4专项认证详情页5学分兑换详情页6干货社区详情页7学习地图详情页
      }
      _this.axios.post(_this.$store.state.api.gra_api + 'record/recordHistory', _this.qs.stringify(
        tmpParams
      )).then(function (res) {
      }).catch(function (error) {
      });
    };

    //多文本文字显示处理
    Vue.prototype.changeSubtitle = function (text) {
      let _text = text ? text.replace(/\n/g, '<br/>') : '暂无信息';

      return _text;
    }
    // ios返回半截白屏问题
    Vue.prototype.iosScrollRestoration = function (prop) {
      // if( _this.$store.state.browser.giantopoapp ){
      //   if( _this.$store.state.browser.ios ){
      if ("scrollRestoration" in history) {
        /*
        *取值： auto/manual
        *改为auto之后，会记录滚动位置
        *改为manual之后，不会记录滚动位置
        *默认在router.beforeEach中设置为manual, 需要缓存的页面在 activated方法中设置为auto
        *
        */
        history.scrollRestoration = prop;
      }
      //   }
      // }
    }
    // 关闭企业微信内嵌H5
    Vue.prototype.closeH5Page = function () {
      if (window.WeixinJSBridge) {
        // 在微信中
        // 这个可以关闭安卓系统的手机
        document.addEventListener(
          'WeixinJSBridgeReady',
          function () {
            window.WeixinJSBridge.call('closeWindow')
          },
          false
        )
        // 这个可以关闭ios系统的手机
        window.WeixinJSBridge.call('closeWindow')
      } else {
        // 在其他浏览器中
        window.close()
      }

    }
    // 指定地址中的参数
    Vue.prototype.getParameterByName = function (name, url) {
      if (!url) {
        url = window.location.href;
      }
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) {
        return null;
      }
      if (!results[2]) {
        return '';
      }

      return results[2].replace(/\+/g, " ");
    }
    // 微信端
    Vue.prototype.IS_WX = function () {
      var isMobile = window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i); // 是否手机端
      var isWx = /micromessenger/i.test(navigator.userAgent); // 是否微信
      if ((isWx && isMobile) || (isWx && !isMobile)) { //手机端微信
        return true
      } else {
        return false
      }


    }
    // 比较两个时间大小
    Vue.prototype.compareDate = function(start, end){
      if(start&&end){
        let reg = new RegExp('-', 'g')
        if(((new Date(start.replace(reg, '/'))) >= (new Date(end.replace(reg, '/'))))){      
          return true;
        }else{       
          return false;
        }
      }else{
        return false
      }
    }

  }
}







// WEBPACK FOOTER //
// ./src/assets/js/site.js